var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floor"},[_c('div',{staticClass:"title-wrap"},[_c('div',{staticClass:"title"},[_vm._t("title"),_c('span',[_vm._t("subTitle")],2)],2),_c('div',{staticClass:"tip"},[_vm._t("tip")],2)]),_vm._t("main")],2)}
var staticRenderFns = []

export { render, staticRenderFns }